var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-10"},[(_vm.currentModule == 'educational-images')?_c('ed-images'):(_vm.currentModule == 'billing-protocols')?_c('billing-protocols'):(_vm.currentModule == 'cl-products')?_c('cl-products'):_c('clinical-references')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }